import { z } from 'zod';

/**
 * QA データタブの検索パラメータ。
 *
 * テスト実施（ExecuteTestCases・単一タスク）は search を使わないが、テストアサインは
 * 2 タスク（SelectTestCases / AssignExecutor）を URL の `operationTaskInstanceId` で
 * 出し分ける（PN「リリースプラン作成」のデータタブと同型）。初回マウント時に
 * InProgress タスクを URL へ注入する。Step1 候補グリッドの絞り込みも search に持つ。
 */
export const dataSearchSchema = z.object({
  operationTaskInstanceId: z.string().optional(),
  freeText: z.string().optional(),
  pageIndex: z.number().optional(),
  level: z.enum(['UNIT', 'INTEGRATION', 'SYSTEM', 'UAT']).optional(),
  type: z.enum(['FUNCTIONAL', 'NON_FUNCTIONAL', 'PERFORMANCE', 'SECURITY', 'ACCESSIBILITY', 'USABILITY', 'RELIABILITY', 'MAINTENANCE', 'PORTABILITY', 'COMPATIBILITY', 'INTEROPERABILITY', 'OTHER']).optional(),
  scope: z.enum(['UNDECIDED', 'CHANGE_UNIT', 'FULL']).optional(),
  status: z.enum(['NOT_STARTED', 'IN_PROGRESS', 'COMPLETED']).optional()
});
export type DataSearch = z.infer<typeof dataSearchSchema>;